import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSocialLinks, selectSocialLinks, selectSocialLinksLoading, selectSocialLinksError } from '../../redux/slices/socialLinksSlice';
import { Box, Typography, Grid, Link } from '@mui/material';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { HiOutlineLocationMarker } from "react-icons/hi";
import styles from './Footer.module.scss';
import { TbApps } from 'react-icons/tb';
import { IoMdCall } from "react-icons/io";
import { FaTiktok } from "react-icons/fa";
import {
    fetchAddress, selectAddress,
    selectAddressLoading,
} from '../../redux/slices/addressSlice';

const Footer = ({ phoneNumber,logo, navLinks, direction, t }) => {
    const dispatch = useDispatch();
    const addressData = useSelector(selectAddress);
    // Get data and state from Redux
    const socialLinks = useSelector(selectSocialLinks);
    const loading = useSelector(selectSocialLinksLoading);
    useEffect(() => {
        dispatch(fetchSocialLinks());
        dispatch(fetchAddress());
      }, [dispatch]);
      const address = addressData.find((item) => item.WebsiteTypeName === 'Address')?.Value || 'No address available';
    const [openLink, setOpenLink] = useState(null);

    const handleToggle = (index) => {
        setOpenLink(openLink === index ? null : index);
    };
    // Data for footer sections
    const sections = [
        {
            title: t.contactUs,
            items: [
                {
                    text: phoneNumber,
                    icon: <IoMdCall style={{ marginLeft: '8px' }} />, // IoMdCall icon added
                },
            ],
        },
        {
            title: t.pages,
            items: navLinks,
        },
        {
            title: t.website,
            items: [
                {
                    text: address,
                    icon: <HiOutlineLocationMarker style={{ marginLeft: '8px' }} />,
                },
            ],
        },
    ];


    // Filter and map the social links
    const socialLinkData = socialLinks
        ?.filter((link) => link.WebsiteTypeName === 'Link') // Filter for links
        .map((link) => {
            let icon = null;
            switch (link.LinkTypeName) {
                case 'FaceBook':
                    icon = <FaFacebookF />;
                    break;
                case 'Instagram':
                    icon = <FaInstagram />;
                    break;
                case 'YouTube':
                    icon = <FaYoutube />;
                    break;
                case 'LinkedIn':
                    icon = <FaLinkedin />;
                    break;
                default:
                    return null; // Skip if no matching icon
            }
            return { icon, href: link.Value };
        })
        .filter(Boolean);


    // if (socialLinksLoading) {
    //     return <p>Loading...</p>;
    //   }

    //   if (error) {
    //     return <p>Error: {error}</p>;
    //   }
    return (
        <Box className={styles.footer}>
            <Grid container spacing={2} sx={{ justifyContent: 'center', mt: 5, width: "100%", ml: "0px !important", paddingLeft: "0px !important", }}>
                {sections.map((section, index) => (
                    <Grid key={index} item xs={12} md={2} sx={{ minWidth: "fit-content", paddingLeft: "0px !important", }}>
                        <Box sx={{ textAlign: { xs: 'center', md: direction === 'ltr' ? 'left' : 'right', }, }}>
                            <Typography
                                variant="h6"
                                className={styles.title}
                            >
                                {section.title}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

                            {section.items.map((item, idx) => (
                                item.sublinks ? ( // Check if the item has sub-links
                                    <Box key={idx}>
                                        <Link
                                            onClick={() => handleToggle(idx)} // Toggle sub-link visibility
                                            className={styles.link}
                                            sx={{ cursor: "pointer" }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: direction === "rtl" ? 'row-reverse' : "row", gap: '8px', justifyContent: { xs: "center", md: direction === 'ltr' ? 'start' : 'end', } }}>
                                                {item.icon && <span className={styles.icon}>{item.icon}</span>} {/* Icon on the right */}
                                                {item.label || item.text} {/* Access the correct property */}
                                            </Box>
                                        </Link>
                                        {openLink === idx && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '8px', justifyContent: { xs: "center", md: direction === 'ltr' ? 'start' : 'end', },  alignItems: {
                                                xs: 'center',  // center for xs (extra-small)
                                                md: direction === 'ltr' ? 'start' : 'end',  // start for ltr and end for rtl on md
                                              }, }}>

                                                {item.sublinks.map((sublink, subidx) => (
                                                    <Link key={subidx} href={sublink.href} className={styles.link} >
                                                        <Typography variant="body2" sx={{ color: '#B0B0B0' }}>
                                                            {sublink.label} {" "}{" "}
                                                        </Typography>
                                                    </Link>
                                                ))}
                                            </Box>
                                        )}


                                    </Box>
                                ) : (
                                    <Link key={idx} href={item.href} className={styles.link} style={{ textDecoration: 'none' }}>
                                        <Typography variant="body2" className={styles.text}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: direction === "rtl" ? 'row-reverse' : "row",
                                                    gap: '8px',
                                                }}
                                            >
                                                {item.icon && <span className={styles.icon}>{item.icon}</span>} {/* Icon on the right */}
                                                {item.label || item.text} {/* Access the correct property */}
                                            </Box>
                                        </Typography>
                                    </Link>

                                )
                            ))}

                        </Box>
                    </Grid>
                ))}

                {/* Logo and Social Media */}
                <Grid
                    item
                    xs={12}
                    md={3}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: { xs: 'center', md: 'flex-end' }, // Center logo on small screens
                        justifyContent: 'center',
                        paddingLeft: "0px !important",
                    }}
                >
                    <Box className={styles.logo}>
                        <img src={logo} alt="Logo"  loading="lazy"/>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '10px', pt: '18px' }}>
                        {socialLinkData.map((social, index) => (
                            <Link key={index} href={social.href} className={styles['social-icon']}>
                                {social.icon}
                            </Link>
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <Box
  className={styles.copyright}
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between', // space out the items
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    gap: { xs: '8px', md: 0 },
    color: 'white',
    textAlign: 'center',
    padding: '10px 20px', // optional padding
  }}
>
  {/* Left Section (Design and Development) */}
  <Typography
    sx={{
      order: { xs: 2, md: 1 },
      position: { md: 'relative', xs: 'relative' },
      left: { md: '15px', xs: 'auto' },
      fontSize: "13px",
      fontWeight: "300"
    }}
  >
    {t.designAndDevelopment}
  </Typography>

  {/* Center Section (Copyright) */}
  <Typography
    sx={{
      fontSize: "13px",
      fontWeight: "300",
      textAlign: 'center',
      order: { xs: 1, md: 2 }
    }}
  >
    {t.copyright}
  </Typography>

  {/* Right Section (Terms and Privacy Policy Links) */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      fontSize: '12px',
      fontWeight: '300',
      justifyContent: 'flex-end', // Align to the right
      order: { xs: 3, md: 3 }, // ensure it appears last
    }}
  >
    <Link href="/terms" color="inherit">{t.termsAndConditions}</Link>
    <Link href="/privacy-policy" color="inherit">{t.privacyPolicy}</Link>
  </Box>
</Box>


        </Box>
    );
};

export default Footer;
